import { apiErrorCodes } from 'consts/api/apiErrorCodes';
import { commonTexts, menusTexts } from 'consts/text';
import { getErrorMessageAndCode } from 'utils/errorHandlers/getErrorMessageAndCode';

export const menuAddEditErrorParser = (error: unknown) => {
    const { code } = getErrorMessageAndCode(error);

    if (code === apiErrorCodes.MENU_DATE_OVERLAPPING) {
        return menusTexts.menuDateOverlappingErrorMessage;
    }

    return commonTexts.errorMessages.unknown;
};
